import * as React from "react"
import * as ReactDOM from "react-dom"

interface IFrequentlyAskedQuestionsProps {
    itemProperties: {
        Title: string;
        Description: string;
        SequenceNumber:number;
    };
    initialState: FrequentlyAskedQuestionsModel<FrequentlyAskedQuestionsItemModel>;
}

class FrequentlyAskedQuestionsModel<T> {
    MainTitle: string;
    MainDescription: string;
    items: Array<T>;
    constructor() {
        this.items = new Array<T>();
    }
}

class FrequentlyAskedQuestionsItemModel {
    Title: string;
    Description: string;
    SequenceNumber:number;

}

export class FrequentlyAskedQuestions extends React.Component<IFrequentlyAskedQuestionsProps, FrequentlyAskedQuestionsModel<FrequentlyAskedQuestionsItemModel>>{
    constructor(props: IFrequentlyAskedQuestionsProps) {
        super(props);
        this.state = (!this.props.initialState) ? new FrequentlyAskedQuestionsModel<FrequentlyAskedQuestionsItemModel>() : this.props.initialState;
    }

    componentDidMount() {
    }


    render() {
        return <section className="section-faq">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="sect-big-head">{this.state.MainTitle}</h3>
                        <p className="sect-sm-text">{this.state.MainDescription}</p>
                    </div>
                    <div className="col-lg-12">
                        <div className="accordion accordion-flush" id="faq">
                            {this.state.items.map((value, index, array) => {
                                return <div className="accordion-item">
                                    <h2 className="accordion-header" id={"q"+`${value.SequenceNumber}`}>
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#ans"+`${value.SequenceNumber}`} aria-expanded="false" aria-controls={"ans"+`${value.SequenceNumber}`}>
                                            <span className="count">{value.SequenceNumber}</span>{value.Title}<i className="bi bi-plus-lg"></i>

                                        </button>
                                    </h2>
                                    <div id={"ans"+`${value.SequenceNumber}`} className="accordion-collapse collapse " aria-labelledby={"q"+`${value.SequenceNumber}`} data-bs-parent="#faq">
                                        <div className="accordion-body">
                                            <div className="acc-content">
                                                <p>{value.Description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    }
}




// WEBPACK FOOTER //
// ./Views/src/frequently-asked-questions.tsx